import { getClient } from '@/services/client';
import { COMMONAPP, COMMONAPPS } from '@/utils/constants';
import { useState } from 'react';
import { useRequest } from 'umi';

export default function useClientModel() {
  const [client, setClient] = useState<API.Client | null>({} as API.Client);
  const [isDemo, setIsDemo] = useState<number>(0);

  const { loading, run } = useRequest(getClient, {
    cacheKey: 'client',
    manual: true,
    formatResult: (res) => res,
    onSuccess: (data) => setClient({ ...data }),
    onError: () => setClient(null),
  });
  
  const isCommonApp = COMMONAPPS.includes(client?.appType) ;

  const isMyHomeCareQuote = client?.appType == COMMONAPP;

  const VERSION_3 = 'generation_3.0';
  const market = client?.market || "US";
  const acceptZipCodeOnly = client?.acceptZipCodeOnly || false;
  const generation = client?.version !== VERSION_3 ? 'generation_1.0' : "generation_3.0";
  return { client, setClient, fetchClient: run, loading, isDemo, setIsDemo, isCommonApp, market, acceptZipCodeOnly, isMyHomeCareQuote, generation };


}
